import { render } from "./PieChartComponent.vue?vue&type=template&id=c36a9216"
import script from "./PieChartComponent.vue?vue&type=script&lang=js"
export * from "./PieChartComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__